// CreatePlacement API calls – extracted from CreatePlacementOrPackageService
import axios from "axios";
import { Constants, CookieService, Utils, authansid } from "../../../shared";

export const createPlacementOrPackage = (campaignId, payload, versionOneApi) => {
  const url = versionOneApi === "V1"
    ? `${Constants.CampaignDataUrl}/${campaignId}/placements?campaign_id=${campaignId}`
    : `${Constants.CampaignDataUrlV2}/${campaignId}/placements?campaign_id=${campaignId}`;
  return axios.post(url, payload, {
    headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const updatePlacementOrPackage = (campaignId, placementId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + '/' + campaignId + '/placements/' + placementId + '?campaign_id=' + campaignId, payload, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const updatePlacements = (campaignId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.patch(url + '/' + campaignId + '/placements?parameter-update=true&campaign_id=' + campaignId, payload, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};
